import React from 'react';
import '@material/web/button/filled-button.js';
import '@material/web/button/filled-tonal-button.js';
import '@material/web/button/outlined-button.js';

/**
 * Button
 * Props:
 *   variant  — 'primary' | 'secondary' | 'danger' | 'ghost'  (default: primary)
 *   size     — 'sm' | 'md' | 'lg'                            (default: md)
 *   loading  — shows a spinner and disables click
 *   icon     — JSX element placed before the label
 *   onClick, disabled, type, className, children
 */
const Button = ({
  variant   = 'primary',
  size      = 'md',
  loading   = false,
  icon      = null,
  children,
  className = '',
  disabled  = false,
  type      = 'button',
  ...rest
}) => {
  const Tag = variant === 'secondary'
    ? 'md-filled-tonal-button'
    : variant === 'ghost'
      ? 'md-outlined-button'
      : 'md-filled-button';

  const sizeClass = size === 'sm' ? 'btn--sm' : size === 'lg' ? 'btn--lg' : '';

  return (
    <Tag
      type={type}
      class={`btn btn--${variant} ${sizeClass} ${className}`.trim()}
      disabled={disabled || loading || undefined}
      {...rest}
    >
      {loading ? (
        <span slot="icon" className="spinner spinner--sm" style={{ margin: '0 4px', borderTopColor: 'currentColor' }} />
      ) : (
        icon && <span slot="icon" style={{ display: 'inline-flex', alignItems: 'center' }}>{icon}</span>
      )}
      {children}
    </Tag>
  );
};

export default Button;
